import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./OtpPage.css";
import logoone from "../../assets/images/lawlogo.png";

interface OtpPageState {
  otp: string[];
  timer: number;
  isResendVisible: boolean;
}

class OtpPage extends Component<{}, OtpPageState> {
  timerInterval: NodeJS.Timeout | null = null;

  constructor(props: {}) {
    super(props);
    this.state = {
      otp: ["", "", "", ""],
      timer: 60,
      isResendVisible: false,
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startTimer = () => {
    this.setState({ timer: 60, isResendVisible: false });
    
    this.timerInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timer <= 1) {
          clearInterval(this.timerInterval!);
          return { timer: 0, isResendVisible: true }; // Explicitly return `isResendVisible`
        }
        return { timer: prevState.timer - 1, isResendVisible: prevState.isResendVisible }; // Ensure it's always included
      });
    }, 1000);
  };
  

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    let newOtp = [...this.state.otp];
    newOtp[index] = e.target.value;
    this.setState({ otp: newOtp });

    if (e.target.value && index < 3) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`) as HTMLInputElement | null;
      if (nextInput) nextInput.focus();
    }
  };

  handleSubmit = () => {
    const enteredOtp = this.state.otp.join("");
    if (enteredOtp.length < 4) {
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    toast.success("OTP Verified Successfully!");
    setTimeout(() => {
      // Navigate to new-password page
    }, 1000);
  };

  handleResend = () => {
    toast.info("OTP Resent Successfully!");
    this.startTimer();
  };

  render() {
    return (
      <div className="otp-container">
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar />
        <div className="otp-card">
          <img src={logoone} alt="Logo" className="brand-logo" />
          <h2 className="otp-heading">Enter OTP</h2>
          <p className="otp-instruction">Enter the 4-digit OTP sent to your email.</p>
          <div className="otp-inputs">
            {this.state.otp.map((data, index) => (
              <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength={1}
                className="otp-input"
                value={this.state.otp[index]}
                onChange={(e) => this.handleChange(e, index)}
              />
            ))}
          </div>
          <button className="submit-button" onClick={this.handleSubmit}>Verify OTP</button>
          
          <p className="timer-text">{this.state.timer > 0 ? `Resend OTP in ${this.state.timer}s` : ""}</p>
          {this.state.isResendVisible && (
            <button className="resend-button" onClick={this.handleResend}>Resend OTP</button>
          )}
        </div>
      </div>
    );
  }
}

export default OtpPage;